import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
export class ErrorBoundary extends Component {
    state = { error: null };
    static getDerivedStateFromError(error) { return { error }; }
    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('UI error:', error, info);
    }
    render() {
        if (this.state.error) {
            return (_jsxs("div", { className: "card", style: { margin: 24 }, children: [_jsx("div", { className: "card-header", children: _jsx("span", { className: "card-title", style: { color: 'var(--ey-error)' }, children: "Something went wrong" }) }), _jsx("pre", { style: { whiteSpace: 'pre-wrap', color: 'var(--ey-muted)', fontSize: 12 }, children: this.state.error.message }), _jsx("button", { className: "btn btn-secondary", onClick: () => location.reload(), children: "Reload" })] }));
        }
        return this.props.children;
    }
}
